import { render, staticRenderFns } from "./UserQualificationTable.vue?vue&type=template&id=61b293e9&"
import script from "./UserQualificationTable.vue?vue&type=script&lang=js&"
export * from "./UserQualificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports